import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import licious  from "../../Assets/Projects/licious.png"
import discoveryPlus  from "../../Assets/Projects/discoveryPlus.png"
import imdb from "../../Assets/Projects/imdb.png";
import dice from "../../Assets/Projects/dice.jpeg"
import sudoku from "../../Assets/Projects/sudoku.png"
import chat from "../../Assets/Projects/chat.png";
import todo from "../../Assets/Projects/todo.png"
import fly91 from "../../Assets/Projects/fly91.png"
import pokemon from "../../Assets/Projects/pokemon.jpeg"
function Projects() {
  return (
   <div id="projectsNavbar">
     <Container fluid className="project-section"  >
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
           
        <Col md={4} className="project-card">
            <ProjectCard
                 imgPath={chat}
              isBlog={false}
              title="Real Time Chat Application"
              description="I developed a real-time chat application using the MERN stack, incorporating features such as one-to-one messaging and group chats.

              Tech Stack : React | Redux | Nodejs | Mongodb | Mongoose | Expressjs | Javascript | CSS | HTML | Chakra ui | Socket.io | Contextapi | Restapi
              
              Features: Signup | Login | Search User | One to one chat | Group Chat | Delete Group
                 "
              ghLink="https://github.com/MeenuKatariya/chatme"
              demoLink="https://chatme-frontend-three.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                 imgPath={fly91}
              isBlog={false}
              title="Fly91"
              description="Fly91 | Bharat Unbound | Website
               TOOL STACK : React | Redux | Javascript | CSS | Html. Using React, JavaScript, HTML, and CSS is a solid tech stack for building modern and interactive user interfaces. If you've created a website with a beautiful UI and a strong frontend, that's a significant accomplishment. It's important to ensure that your website not only looks appealing but also provides a smooth and intuitive user experience.
                 "
              ghLink="https://github.com/MeenuKatariya/Sociopedia-App"
              demoLink="https://fly91.in/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
                 imgPath={pokemon}
              isBlog={false}
              title="Pokemon App"
              description="  Pokemon App | TOOL STACK : React | Redux | Javascript | CSS | Html | Ant Design. Using React, JavaScript, HTML, and CSS | Search: Find your favorite Pokemon with a smart search feature.
              Filter: Easily filter and sort Pokemon based on various criteria.
              Data Presentation: Detailed data model presentation for each Pokemon.
                 "
              ghLink="https://github.com/MeenuKatariya/pokemon-app"
              demoLink="https://pokemon-app-zkdn-sie7eezsz-meenukatariya.vercel.app/"           />
          </Col>
        </Row>
      </Container>
    </Container>
   </div>
  );
}

export default Projects;
